import cn from "classnames"

import { IconTag } from "../IconTag"
import { ApplicationInkTag } from "./ApplicationInkTag"

import styles from "./ApplicationTag.module.scss"

import type { ApplicationTagProps } from "./ApplicationTag.types"

export const ApplicationTag = (props: ApplicationTagProps) => {
  const { type } = props
  const isTerminated = type === "terminated"
  const className = cn({
    [styles.active]: type === "active",
    [styles.inactive]: type === "inactive",
    [styles.terminated]: isTerminated,
    [styles.tag]: props.tag
  })

  if (!props.tag) return <ApplicationInkTag className={className} {...props} />

  return (
    <IconTag
      classes={{ tag: className }}
      text={<ApplicationInkTag {...props} />}
    />
  )
}
